import React, { useState } from 'react'
import styles from './ClientDataList.module.scss'
import { ReactComponent as OpenClient } from 'components/CRM/UI/icons/arrow-down-s-line.svg'
import ActionMenu from 'components/UI/ActionMenu/ActionMenu'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import { colors } from 'components/ContentBox/Global/ContentTable_test/avatar'
import useLocalization from 'hooks/useLocalization'

export const ClientDataList = ({ client, index, action }) => {
  const [expanded, setExpanded] = useState(false)

  const { translate } = useLocalization({
    section: 'groups',
    subsection: 'all_groups',
    dict: {
      activate_client: 'Activate client',
      inactive_client: 'Inactive client',
      edit_client: 'Edit client',
      inn_iin: 'INN/IIN',
      level: 'Level',
      comment: 'Comment',
      client_verification: 'Client verification',
      deActive_client: 'Deactivate client',
      active_client: 'Activate client',
    },
  })

  const toggleExpand = () => {
    setExpanded(!expanded)
  }

  const menu = [
    { name: translate?.edit_client, action: 'edit_client' },
    ...(client.is_active
      ? [{ name: translate?.deActive_client, action: 'deactivate_client' }]
      : [
          {
            name: translate?.active_client,
            action: 'activate_client',
          },
        ]),
  ]

  return (
    <>
      <div
        className={`${styles.clientContainer} ${index % 2 === 0 ? styles.colorBg : ''} ${expanded && styles.colorBgActive}`}
      >
        <div className={styles.containerInf}>
          <div className={`${styles.infStyl} ${styles.name}`}>
            {client.name}
          </div>
          <div className={`${styles.infStyl} ${styles.phone}`}>
            {client.phone}
          </div>
          <div className={`${styles.infStyl} ${styles.email}`}>
            {client.email}
          </div>
          <div className={styles.buttons}>
            {!client.is_verified &&
            (client.phone || client.email) &&
            client.is_active ? (
              <div
                className={styles.verification}
                onClick={() => action('client_verification', null, client)}
              >
                {translate.client_verification}
              </div>
            ) : (
              <div className={styles.styles} />
            )}
            <div
              className={`${styles.buttonClient} ${expanded ? styles.rotate : ''}`}
              onClick={toggleExpand}
            >
              <OpenClient className={styles.btnArrow} />
            </div>
            <ActionMenu menu={menu} action={action} items={client} />
          </div>
        </div>
      </div>
      {expanded && (
        <div className={styles.clientDetails}>
          <div className={styles.avatar}>
            {client.is_active ? (
              <div
                className={`${styles.activeClient} ${styles.activeColorClient}`}
              >
                {translate?.activate_client}
              </div>
            ) : (
              <div
                className={`${styles.activeClient} ${styles.inactiveColorClient}`}
              >
                {translate?.inactive_client}
              </div>
            )}
            <div
              className={styles.photo}
              style={{
                backgroundColor: colors(
                  client.name
                    .split(' ')
                    .map((name) => name.charAt(0).toUpperCase())
                    .join(''),
                ),
              }}
            >
              {client.name
                .split(' ')
                .map((name) => name.charAt(0).toUpperCase())
                .join('')}
            </div>
          </div>
          <div className={styles.infoColumnOne}>
            <div className={styles.formField}>
              <FormLabel>{'Email:'}</FormLabel>
              <div className={styles.input}>
                {client.email ? <div>{client.email}</div> : <div>Email</div>}
              </div>
            </div>
            <div className={styles.formField}>
              <FormLabel>{translate?.inn_iin}:</FormLabel>
              <div className={styles.input}>
                {client.inn ? (
                  <div>{client.inn}</div>
                ) : (
                  <div>{translate?.inn_iin}</div>
                )}
              </div>
            </div>
            <div className={styles.formField}>
              <FormLabel>{'WhatsApp:'}</FormLabel>
              <div className={styles.input}>
                {client.whatsapp ? (
                  <div>{client.whatsapp}</div>
                ) : (
                  <div>WhatsApp</div>
                )}
              </div>
            </div>
          </div>
          <div className={styles.infoColumnTwo}>
            <div className={styles.formField}>
              <FormLabel>{'Instagram:'}</FormLabel>
              <div className={styles.input}>
                {client.instagram ? (
                  <div>{client.instagram}</div>
                ) : (
                  <div>Instagram</div>
                )}
              </div>
            </div>
            <div className={styles.formField}>
              <FormLabel>{'Telegram:'}</FormLabel>
              <div className={styles.input}>
                {client.telegram ? (
                  <div>{client.telegram}</div>
                ) : (
                  <div>Telegram</div>
                )}
              </div>
            </div>
            <div className={styles.formField}>
              <FormLabel>{translate?.level}:</FormLabel>
              <div className={styles.input}>
                {client.studentLevel ? (
                  <div>{client.studentLevel}</div>
                ) : (
                  <div>{translate?.level}</div>
                )}
              </div>
            </div>
          </div>
          <div className={styles.comment}>
            <FormLabel>{translate?.comment}:</FormLabel>
            <div className={styles.commentInput}>
              {client.comment ? (
                <div>{client.comment}</div>
              ) : (
                <div>{translate?.comment}</div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  )
}
